import { SpaceBetween } from '@cloudscape-design/components';
import { Box } from '@cloudscape-design/components';
import type { PlaceReportContact } from '../common/types';
import { useMemo } from 'react';
import { formatName } from '../common/names';
import { PhoneNumber } from './PhoneNumber';
import { Email } from './Email';

export type PlaceReportContactsListProps = {
  contacts: PlaceReportContact[];
  hideReferenceName?: boolean;
  showLineTypeInfo?: boolean;
};

export function PlaceReportContactsList(props: PlaceReportContactsListProps) {
  const contacts = useMemo(() => {
    return props.contacts
      .filter((contact) => !contact.hidden)
      .sort((a, b) => {
        return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
      });
  }, [props.contacts]);

  return (
    <SpaceBetween size="xxxs" direction="vertical">
      {contacts.map((contact) => {
        return (
          <SpaceBetween size="xxxs" direction="vertical" key={contact.uuid}>
            <Box variant="span">
              <Box variant="span">{formatName(contact.first_name, contact.last_name)}</Box>
              {contact.title && `, ${contact.title}`}
            </Box>
            <PhoneNumber
              phoneNumber={contact.phone_number}
              lineTypeInfo={contact.phone_line_type_info}
              showLineTypeInfo={props.showLineTypeInfo}
            />
            <Email email={contact.email} />
            {!props.hideReferenceName && contact.reference_name && (
              <Box variant="span" color="text-body-secondary">
                Feedback Rep: {contact.reference_name}
              </Box>
            )}
          </SpaceBetween>
        );
      })}
    </SpaceBetween>
  );
}
